import { useQuery } from '@tanstack/react-query';
import { NO_CAPABILITIES } from '../api/capabilityContracts';
import { workspaceService } from '../services/workspaceService';
import type { Capabilities } from '../types/workspace.types';
import { workspaceKeys } from './workspaceKeys';

/** Capabilities change only when Core is redeployed. */
const CAPABILITIES_STALE_TIME_MS = 5 * 60_000;

export interface CapabilitiesState {
  /** Every flag off until Core has answered, and while it cannot be reached. */
  readonly capabilities: Capabilities;
  readonly isPending: boolean;
}

/**
 * What the deployed Core supports, for deciding which v1 pages and actions to show.
 *
 * Fails closed: while loading, after an error, or against a Core that has no
 * capabilities route, every flag is off, so the app looks exactly as it did before.
 */
export function useCapabilities(): CapabilitiesState {
  const query = useQuery({
    queryKey: workspaceKeys.capabilities,
    queryFn: () => workspaceService.getCapabilities(),
    staleTime: CAPABILITIES_STALE_TIME_MS,
  });

  return { capabilities: query.data ?? NO_CAPABILITIES, isPending: query.isPending };
}
